export const STATUS = {
  new: {
    key: 'new',
    value: 'new',
    text: 'New',
    permission: 'changeStatus',
    color: 'info',
  },
  review: {
    key: 'review',
    value: 'review',
    text: 'In review',
    permission: 'submitReview',
    color: 'warning',
  },
  approved: {
    key: 'approved',
    value: 'approved',
    text: 'Approved',
    permission: 'changeStatus',
    color: 'success',
  },
  canceled: {
    key: 'canceled',
    value: 'canceled',
    text: 'Canceled',
    permission: 'changeStatus',
    color: 'error',
  },
}

export const FINAL_STATUSES = [
  STATUS.approved.value, STATUS.canceled.value
]
export const STATUS_ALLOW_DELETE = [
  STATUS.new.value
]
